module.exports = {
  "/signup-v2/embedded": {},
  "/signup-v2/embedded/step/join-hubspot": {
    "success": [
      "USER_REGISTRATION_USER_GRID"
    ]
  },
  "/signup-v2/embedded/:portal/step/join-hubspot-academy": {},
  "/signup-v2/:flow/:portal/step/getting-started": {},
  "/signup-v2/step/google-oauth": {},
  "/signup-v2/:flow/step/detect-auth": {},
  "/signup-v2/:flow/step/create": {},
  "/signup-v2/embedded/step/existing-accounts-minimal": {
    "success": [
      "EXISTING_ACCOUNTS_MINIMAL"
    ]
  },
  "/signup-v2/:flow/step/complete-verification": {
    "success": {
      "emailConfirmed": [
        "EMAIL_CONFIRMED"
      ],
      "tokenExpiredOrNotExisting": [
        "CONFIRM_EMAIL_FAILED"
      ]
    }
  },
  "/signup-v2/:flow/step/company-domain": {
    "success": [
      "COMPANY_DOMAIN"
    ]
  },
  "/signup-v2/crm/step/check-your-email": {
    "success": [
      "CHECK_YOUR_EMAIL"
    ]
  },
  "/signup-v2": {},
  "/signup-v2/:flow": {
    "success": {
      "verifiedFlow": [
        "VERIFIED_USER_INFO"
      ],
      "notVerifiedGrid": [
        "USER_REGISTRATION_USER_GRID"
      ],
      "notVerifiedFull": [
        "USER_REGISTRATION_USER_FULL_WIDTH"
      ],
      "wordpressNewCustomer": [
        "WORDPRESS_NEW_CUSTOMER"
      ],
      "existingUser": [
        "EXISTING_USER"
      ]
    }
  },
  "/signup-v2/:flow/step/user-info": {
    "success": {
      "verifiedFlow": [
        "VERIFIED_USER_INFO"
      ]
    }
  },
  "/signup-v2/:flow/step/join-hubspot-account": {
    "success": {
      "notVerifiedGrid": [
        "USER_REGISTRATION_USER_GRID"
      ],
      "notVerifiedFull": [
        "USER_REGISTRATION_USER_FULL_WIDTH"
      ]
    }
  },
  "/signup-v2/:flow/step/wordpress-intro": {
    "success": {
      "wordpressNewCustomer": [
        "WORDPRESS_NEW_CUSTOMER"
      ]
    }
  },
  "/signup-v2/:flow/step/existing-user": {
    "success": {
      "existingUser": [
        "EXISTING_USER"
      ]
    }
  }
};